export default __webpack_public_path__ + "static/media/A3.9cc998f4.png";